import React from 'react';
import { motion } from 'framer-motion';
export function SocialProofSection() {
  return <section className="bg-charcoal-900" data-id="element-60">
      {/* Quote Section */}
      <div className="py-24 px-6 md:px-8 max-w-5xl mx-auto text-center relative" data-id="element-61">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.5
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-62">
          <div className="text-patriotRed text-6xl md:text-8xl font-serif leading-none mb-6" aria-hidden="true" data-id="element-63">
            &ldquo;
          </div>
          <blockquote className="text-2xl md:text-4xl font-serif italic text-offwhite leading-relaxed mb-8" data-id="element-64">
            They said he was dangerous. Not because he carried a weapon, but
            because he carried a microphone. Not because he threatened violence,
            but because he threatened the silence they had so carefully
            constructed.
          </blockquote>
          <cite className="text-offwhite-muted uppercase tracking-widest text-sm font-semibold not-italic" data-id="element-65">
            — From the Prologue
          </cite>
        </motion.div>
      </div>
    </section>;
}